import { Injectable, OnInit } from '@angular/core';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { User } from 'src/app/user';
import { userPassword } from 'src/app/domain/userPassword';


export interface ApplianceRole {
  id: number;
  roleName: string;
  orderManagement: boolean;
  stockManagement: boolean;
  inventoryManagement: boolean;
  fileProcessingManagement: boolean;
  RFPManagement: boolean;
  prospectsManagement: boolean;
  accessLevel: number;
  
}


export interface CadenceRole {
  roleId: number;
  userRole: string;
  userManagement: boolean;
  customerManagement: boolean;
  lookupManagement: boolean;
  techLeadAccess: boolean;
  cadenceMenu : boolean;
  accessLevel : number;
  opportunityManagement : boolean;
  newOpportunityManagement : boolean;
}


export enum AccessLevelEnum  {
  no_access = 0,
  read_only = 1,
  read_write = 2,
  full_access = 3
}



@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private userLoggedIn = new Subject<boolean>();

  private isloggedIn = false;

  public applanceRole :ApplianceRole;
  public cadenceRole : CadenceRole;
  cdr: any;

  private loginCompleted = new Subject<void>();
  loginCompleted$ = this.loginCompleted.asObservable();


  constructor(private httpClient: HttpClient) {
    this.userLoggedIn.next(false);


  }




  // authenticate(user: User) {
  //   const headers = new HttpHeaders({ Authorization: 'Basic ' + btoa(user.email + ':' + user.password) });
  //   return this.httpClient.get('/validateLogin', { headers, responseType: 'text' }).pipe(
  //     map(
  //       userData => {
  //         this.setUserLoggedIn(true);
  //         sessionStorage.setItem("loginUserName", user.email);
  //         let authString = 'Basic ' + btoa(user.email + ':' + user.password);
  //         console.log('Test 1');
  //         sessionStorage.setItem('basicauth', authString);
  //         console.log('userData :', userData);

  //         localStorage.setItem("loginUserName", user.email);
  //         localStorage.setItem('basicauth', authString);
  //         return userData;
  //       }
  //     ), catchError(this.errorHandler)
  //   );
  // }


  authenticate(user: User) {
    const headers = new HttpHeaders({ Authorization: 'Basic ' + btoa(user.email + ':' + user.password) });
    return this.httpClient.get('/validateLogin', { headers, responseType: 'text' }).pipe(
      map((response: string) => {
        const parsedResponse = JSON.parse(response);

        if (parsedResponse.status === 'ok') {
          console.log('Valid login credentials');
          this.setUserLoggedIn(true);
          sessionStorage.setItem("loginUserName", user.email);
          const authString = 'Basic ' + btoa(user.email + ':' + user.password);
          sessionStorage.setItem('basicauth', authString);
          localStorage.setItem("loginUserName", user.email);
          localStorage.setItem('basicauth', authString);

          localStorage.setItem("token" , parsedResponse.token);
          sessionStorage.setItem("token" , parsedResponse.token);


          const rolesJsonString = parsedResponse.roles;

          // Parse the roles JSON string into an object
          const roles = JSON.parse(rolesJsonString);

          // Extract specific roles
          this.applanceRole = roles['appliance-role'];
          this.cadenceRole = roles['cadence-role'];


          this.loginCompleted.next();


          this.isloggedIn = true;
          return response;
        } else if (parsedResponse.status === 'invalid') {
          this.setUserLoggedIn(false);

        }else if (parsedResponse.status === 'resetPassword') {
          const authString = 'Basic ' + btoa(user.email + ':' + user.password);
          sessionStorage.setItem('basicauth', authString);
          this.setUserLoggedIn(false);
          return response;
        }
      }),
      catchError(this.errorHandler)
    );
  }

  resetPassword(user: User) {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/updatePassword', user, { headers }).pipe(catchError(this.errorHandler));
  }

  updateUserPassword(password: userPassword) {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/updateUserPassword', password, { headers });
  }

  // using in mult tab
  isUserLoggedIn() {
    let user = localStorage.getItem('loginUserName');
    let basicauth = localStorage.getItem('basicauth');

    if ((user === null) && (basicauth === null)) {
      return false;
    }
    sessionStorage.setItem('loginUserName', user);
    sessionStorage.setItem('basicauth', basicauth);
    this.loginCompleted.next();
    return true;
  }

  // isUserLoggedIn() {
  //   let user = sessionStorage.getItem('loginUserName');
  //   console.log(!(user === null))
  //   return !(user === null)
  // }

  // logOut() {
  //   this.setUserLoggedIn(false);
  //   sessionStorage.removeItem("loginUserName");
  //   sessionStorage.removeItem("8");
  //   sessionStorage.clear();
  //   localStorage.clear();
  //   window.location.reload();
  // }

  logOut() {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });

    return this.httpClient.post<any>('/api/logout/', { headers, responseType: 'text' }).pipe(
      map(response => {
        this.clearStorageAndReload();
        return response;
      }),
      catchError(this.errorHandler)
    );
  }


  private clearStorageAndReload() {
    sessionStorage.clear();
    let filters = localStorage.getItem('Filters');
    localStorage.clear();
    if (filters) {
      localStorage.setItem('Filters', filters);
    }
    window.location.reload();
    
  }

  private clearAllCookies() {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    }
  }


  errorHandler(error: HttpErrorResponse) {
    console.log('this is error in auth: ', error);
    return throwError(error.message || 'Server Error');

  }

  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }

  checkLoggedIn(): boolean{
    return this.isloggedIn;
  }


   getApplanceRole(): ApplianceRole {
    return this.applanceRole  ;
  }

   getCadenceRole(): CadenceRole {
    return this.cadenceRole ;
  }

  setApplanceRole( applianceRole :any): ApplianceRole {
    return this.applanceRole  = applianceRole;
  }

   setCadenceRole(cadenceRole : any): CadenceRole {
    return this.cadenceRole  =cadenceRole ;
  }

 
  // getPermissions() {
  //   const token = sessionStorage.getItem('token');
  //   const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  //   if (token != null) {
  //     return this.httpClient.get<any>(, { headers }).pipe(
  //       map(response => {
  //         console.log('Permissions:', response);
  //         this.applanceRole = response['appliance-role'];
  //         this.cadenceRole = response['cadence-role'];
  //       }),
  //       catchError(error => {
  //         console.error('Error fetching permissions:', error);
  //         return throwError(error);
  //       })
  //     ).subscribe(); 
  //   }
  // }


  getPermissions(): Observable<any> {
    const token = localStorage.getItem("token");
    if (!token) {
      return of(null);  // Immediately return an observable with null if token is missing
    }

    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<any>( 'appliances/api/v2/auth/permissions', null ,{ headers })
      .pipe(
        map(response => {
          const applianceRole = response['appliance-role'];
          const cadenceRole = response['cadence-role'];
  
      
          return { applianceRole, cadenceRole };
        }),
        catchError(error => {
          console.error('Error fetching permissions:', error);
          return of(null);  // Return null in case of an error
        })
      );
  }
  
  
  

}
